import React from 'react'
import ExpenseCategories from 'src/app/ExpenseCategories/ExpenseCategories'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import ExpenseCategoriesAccountingAppRoute from 'src/navigation/appRoutes/organization/expenseCategoriesAccounting.appRoute'
import ExpenseCategoriesAdditionalFieldsAppRoute from 'src/navigation/appRoutes/organization/expenseCategoriesAdditionalFields.appRoute'
import { expenseCategoriesRouteProps } from 'src/navigation/routeProps'

const ExpenseCategoriesAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsExpenseCategories,
  routeProps: expenseCategoriesRouteProps,
  component: <ExpenseCategories />,
  subRoutes: [
    ExpenseCategoriesAccountingAppRoute,
    ExpenseCategoriesAdditionalFieldsAppRoute,
  ],
  meta: { contentType: SidenavContentType.Settings },
}

export default ExpenseCategoriesAppRoute
